import React from 'react'
import clsx from 'clsx'

import { External } from '/react4xp/components/Svg/Ux/Ux'

export interface MacroInternalLinkButtonProps {
  theme: 'light' | 'dark'
  text: string
  link: string
}

export default function MacroInternalLinkButton({
  theme,
  text,
  link,
}: MacroInternalLinkButtonProps) {
  return (
    <a
      href={link}
      className={clsx(
        'macro__button',
        theme === 'light' && 'macro__button--light'
      )}
    >
      <span>{text}</span>
      <External />
    </a>
  )
}